module.exports = __webpack_public_path__ + "static/media/like_artist_img.54e8cf90.png";